import { IEmailSender } from "@/domain/application/sender/IEmailSender";
import { Lead } from "@/domain/entities/Lead";
import { NodemailerService } from "./nodemailer";
import { env } from "@/infra/env";

export class NodemailerTruckEmailSender implements IEmailSender {
  private mailer_host: string = env.MAILER_HOST
  private mailer_port: number = env.MAILER_PORT
  private mailer_username: string = env.MAILER_USERNAME
  private mailer_from_name:string = env.MAIL_FROM_ADDRESS
  private mailer_password: string = env.MAILER_PASSWORD
  private mailer_security: boolean = env.MAILER_SECURITY
  private nodemailer_service: NodemailerService = new NodemailerService(
    this.mailer_host,
    this.mailer_port,
    this.mailer_username,
    this.mailer_password,
    this.mailer_security
  )
  async send(lead: Lead): Promise<{ status: string; }> {
    try {
      const message = `Hello ${lead.name} from truck`

    const {info} = await this.nodemailer_service.sendMail(
      this.mailer_username,
      this.mailer_from_name,
      lead.email,
      'test-leads-lg',
      message
    )

    return {status: info.accepted ? 'sended' : 'error'}
    } catch (error) {
      console.log(error)
      if(error instanceof Error){
        return {status: error.stack ? 'error' : ''}
      }
      return {status: 'error'}
    }
  }
}